import { useState } from 'react';

export default function useToggle(initialValue = false): [boolean, () => void] {
    const [value, setValue] = useState(initialValue);
    const toggle = () => setValue((prevValue) => !prevValue);
    return [value, toggle];
}
